import type { InjectionKey } from 'vue';
import type { Modal } from './modal';

export const modalKey = Symbol('modal') as InjectionKey<Modal>;
